import { computed, inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState
} from '@ngrx/signals';

import { USER_STORE } from '@core/stores/user.store';

interface ZendeskState {
  isOpen: boolean;
  unreadCount: number;
}

const initialState: ZendeskState = {
  isOpen: false,
  unreadCount: 0
};

export const ZENDESK_STORE = signalStore(
  withState(initialState),
  withComputed((_store, userStore = inject(USER_STORE)) => ({
    canShowWidget: computed(() => !!userStore.data())
  })),
  withMethods(store => ({
    setOpen(isOpen: boolean): void {
      patchState(store, { isOpen });
    },

    setUnreadCount(unreadCount: number): void {
      patchState(store, { unreadCount });
    },

    reset(): void {
      patchState(store, initialState);
    }
  }))
);
